import _reduce from 'lodash/reduce'
import { connect } from 'react-redux'
import LoginWindow from '../../components/LoginWindow'
import localize from '../../store/localize'
import strings from '../../components/LoginWindow/login-window.json'
import {
    actionUsersLogInUser,
    actionSteamSave,
    actionUpdateAutoLaunchOnStartup,
} from '../../actions'
import attributes from '../../settings/references.json'
import { selectors } from '../../features/Settings'
import { actions as toasterActions } from '../../features/Toaster'

// Check if we have a user list available
// if one is available, count the entries
function getUserCount(users, server) {
    if (users.list == null || users.list[server] == null) return 0

    return _reduce(
        users.list[server],
        (r, v) => {
            if (v.shell === true) return r
            return r + 1
        },
        0,
    )
}

function mapStateToProps(state) {
    const { servers, versions, steam, users } = state
    const locale = selectors.getLanguage(state)
    const server = servers.list[servers.active]
    const showCancel = getUserCount(users, servers.active) > 0
    const userAgent = attributes.launcher.user_agent.replace('{version}', versions.ui)

    return {
        server,
        autoLaunch: selectors.getAutoLaunchOnLogin(state),
        language: locale,
        userAgent,
        steam,
        showCancel,
        localize: value => localize(strings, locale, value),
        updateLaunchOnStartup: () => actionUpdateAutoLaunchOnStartup(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loginUser: (server, user) => {
            dispatch(actionUsersLogInUser(server, user))
            window.setToken()
        },
        updateSteam: (steam) => {
            const input = { ...steam, usedTicket: steam.steamTicket }
            dispatch(actionSteamSave(input))
        },
        displayError: (message) => {
            dispatch(toasterActions.addError(message))
        },
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        server: stateProps.server,
        autoLaunch: stateProps.autoLaunch,
        userAgent: stateProps.userAgent,
        steam: stateProps.steam,
        language: stateProps.language,
        displayError: message =>
            dispatchProps.displayError({ title: stateProps.localize('error'), message }),
        showCancel: stateProps.showCancel,
        loginUser: (user) => {
            dispatchProps.loginUser(stateProps.server.shortName, user)
        },
        updateSteam: () => {
            // Clone the Steam object
            const steam = { ...stateProps.steam }

            // Update has logged in state
            steam.hasLoggedIn = true

            // Update the steam status
            dispatchProps.updateSteam(steam)
        },
        onReady: ownProps.onReady,
        displayLoginWindow: ownProps.displayLoginWindow,
        ssoStatusCheck: ownProps.ssoStatusCheck,
        localize: stateProps.localize,
        updateLaunchOnStartup: stateProps.updateLaunchOnStartup,
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(LoginWindow)



// WEBPACK FOOTER //
// ./src/containers/LoginWindow/login-window.js